export default {"src":"/_next/static/media/healthOutline33_40.6fa31079.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};